import { render } from "./selectFootModel.vue?vue&type=template&id=75120928"
import script from "./selectFootModel.vue?vue&type=script&lang=js"
export * from "./selectFootModel.vue?vue&type=script&lang=js"

import "./selectFootModel.vue?vue&type=style&index=0&id=75120928&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__